import { isVoiceTask } from "../../agent/voice/typeGuards";
import { useCallbackState } from "./useCallback";
import { useSession } from "./useSession";

/**
 * NOTE: This function must be used with an active voice task. Any other task types will return undefined.
 *
 * Will provide the most recent known task, callback, or last task MDN for a session otherwise undefined.
 * This can and should be used to replace direct task MDN or callback MDN use cases for UI display
 */
export function useSessionActiveCallerId() {
    const session = useSession();
    const callbackState = useCallbackState();
    const currentTask = session.currentTask;

    if (isVoiceTask(currentTask)) {
        return currentTask.callerId;
    }

    if (callbackState?.callbackMDN) {
        return callbackState.callbackMDN;
    }

    const prevTask = Array.from(session.tasks.values()).at(-1);
    if (isVoiceTask(prevTask)) {
        return prevTask.callerId;
    }

    return undefined;
}
